import Image from 'next/image';
import styles from './TrendsDiCatCta.module.css';

type props = {
    bannerType: string
}
export function TrendsDiCatCta({ bannerType }: props) {
    const getBanner = () => {
        switch (bannerType) {
            case 'kitchen':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/cook_style_comfort.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_7f885d}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Cook in Style and Comfort.</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Get Free Estimate</button>
                    </div>
                </section>
            case 'ceiling':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/stylish_ceilings.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_305593}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Elevate with Stylish Ceilings!</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Book Free Consultation</button>
                    </div>
                </section>
            case 'balcony':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/balcony_escape.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_d6924c}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Create a Scenic Balcony Escape.</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Get a Quote</button>
                    </div>
                </section>
            case 'pooja_mandir':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/infuse_spirituality.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_f88611}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Infuse Spirituality into Design.</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Get Started Now</button>
                    </div>
                </section>
            case 'walls':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/transform_walls.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_4a88ac}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Transform Walls, Transform Homes.</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Talk To Us Today!</button>
                    </div>
                </section>
            case 'closet':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/closet_chic.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_b9c7d5}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Style Your Closet Chic!</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Book Now</button>
                    </div>
                </section>
            case 'living_space':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/infuse_style.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_617c75}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Infuse Style into Living Spaces.</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Let&apos;s Chat</button>
                    </div>
                </section>
            case 'bedroom':
                return <section className={`ctaForm ${styles.trends_banner_sec}`} >
                    <figure className={`dFlex ${styles.designing_img}`}>
                        <Image width={460} height={280} src="/assets/images/craft_cozy.webp" alt="banner_img" className="img-responsive" />
                    </figure>
                    <div className={`${styles.sectn_details} ${styles.bg_d9c6bc}`}>
                        <p className={`${styles.title_txt} font30 textfff fbold`}>Craft Cozy Bedroom Bliss.</p>
                        <button type="button" className={`${styles.know_more} btnPrimery font16`} >Get in Touch</button>
                    </div>
                </section>
            default:
                return <></>
        }
    }
    return (getBanner())
}